import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'
import { setInfoKey } from '../../api/information-collection/actions'


export const insuranceTakersTypes = createTypes(['SET_KEY', 'ADD_INSURANCE_TAKER'], 'INSURANCE_TAKERS');

export const setKey = (keyValue, insuranceTakerId) => {
    return {
        type: insuranceTakersTypes.SET_KEY,
        key: keyValue.key,
        value: keyValue.value,
        insuranceTakerId: insuranceTakerId,
    };
};

export const addInsuranceTakerFromNationalRegistry = (insuranceTaker) => {
    return {
        type: insuranceTakersTypes.ADD_INSURANCE_TAKER,
        insuranceTaker: insuranceTaker,
    };
};